// ─── Delays ──────────────────────────────────────────────────────────────────

export const ScanToPayDelays = {
  TOKEN_POLLING_DELAY: 120_000,
  CREDITS_POLLING_DELAY: 120_000,
};
